export default __webpack_public_path__ + "static/media/Setting_Phantasia.78ee345c.svg";